import styled from 'styled-components'
import { IPropsSuspenseLoading } from './IProps'

export const PreLoadingContainer = styled.section<IPropsSuspenseLoading>`
  height: 100%;
  width: 100%;
  position: ${props => (props.position === 'parent' ? 'absolute' : 'fixed')};
  top: 0;
  left: 0;
  right: 0;
  z-index: ${props => (props.position === 'parent' ? '10' : '999')};
`
